import { ApiBookingPane } from '@ibe/api';

export enum BookingPaneSortKeys {
  BOOKINGNUMBER = 'bookingNumber',
  BOOKINGSTATE = 'bookingState',
  BOOKINGDATE = 'bookingDate',
  TRAVELSTARTDATE = 'travelStartDate',
  PRICE = 'price',
  AGENT = 'agent',
  LEADTRAVELERNAME = 'leadTravelName'
}

export enum SortingOrder {
  ASC,
  DES
}

export default abstract class BookingListUtil {
  public static sortItems(
    key: BookingPaneSortKeys,
    order: SortingOrder,
    items: ApiBookingPane[]
  ): ApiBookingPane[] {
    let sortedItems;
    if (SortingOrder.DES === order) {
      sortedItems = items.sort((a: ApiBookingPane, b: ApiBookingPane) =>
        this.compareElements(key, a, b, -1)
      );
    } else {
      sortedItems = items.sort((a: ApiBookingPane, b: ApiBookingPane) =>
        this.compareElements(key, a, b, 1)
      );
    }
    return sortedItems;
  }

  private static compareElements(
    key: BookingPaneSortKeys,
    first: ApiBookingPane,
    second: ApiBookingPane,
    revertedOrderSwitch: number
  ): number {
    switch (key) {
      case BookingPaneSortKeys.BOOKINGNUMBER:
        return this.compareBookingNumbers(first, second, revertedOrderSwitch);
      case BookingPaneSortKeys.BOOKINGSTATE:
        return this.compareBookingStates(first, second, revertedOrderSwitch);
      case BookingPaneSortKeys.BOOKINGDATE:
        return this.compareDates(first.bookingDate, second.bookingDate, revertedOrderSwitch);
      case BookingPaneSortKeys.TRAVELSTARTDATE:
        return this.compareDates(
          first.travelStartDate,
          second.travelStartDate,
          revertedOrderSwitch
        );
      case BookingPaneSortKeys.PRICE:
        return this.comparePrices(first, second, revertedOrderSwitch);
      case BookingPaneSortKeys.AGENT:
        return this.compareAgents(first, second, revertedOrderSwitch);
      default:
        return 0;
    }
  }

  private static compareBookingNumbers(
    first: ApiBookingPane,
    second: ApiBookingPane,
    revertedOrderToken: number
  ): number {
    if (first.bookingNumber && second.bookingNumber) {
      if (Number(first.bookingNumber) < Number(second.bookingNumber)) {
        return -1 * revertedOrderToken;
      }
      if (Number(first.bookingNumber) > Number(second.bookingNumber)) {
        return revertedOrderToken;
      }
    }
    return 0;
  }

  private static compareBookingStates(
    first: ApiBookingPane,
    second: ApiBookingPane,
    revertedOrderToken: number
  ): number {
    if (first.bookingState && second.bookingState) {
      if (first.bookingState < second.bookingState) {
        return -1 * revertedOrderToken;
      }
      if (first.bookingState > second.bookingState) {
        return revertedOrderToken;
      }
    }

    return 0;
  }

  private static compareDates(
    firstDate: string | undefined,
    secondDate: string | undefined,
    revertedOrderToken: number
  ): number {
    if (firstDate && secondDate) {
      const a = new Date(firstDate);
      const b = new Date(secondDate);
      if (a < b) {
        return -1 * revertedOrderToken;
      }
      if (a > b) {
        return revertedOrderToken;
      }
    }
    return 0;
  }

  private static comparePrices(
    first: ApiBookingPane,
    second: ApiBookingPane,
    revertedOrderToken: number
  ): number {
    if (first.price && second.price) {
      if (first.price.finalPrice < second.price.finalPrice) {
        return -1 * revertedOrderToken;
      }
      if (first.price.finalPrice > second.price.finalPrice) {
        return revertedOrderToken;
      }
    }
    return 0;
  }

  private static compareAgents(
    first: ApiBookingPane,
    second: ApiBookingPane,
    revertedOrderToken: number
  ): number {
    if (first.agent && second.agent && first.agent.lastName && second.agent.lastName) {
      if (first.agent.lastName < second.agent.lastName) {
        return -1 * revertedOrderToken;
      }
      if (first.agent.lastName > second.agent.lastName) {
        return revertedOrderToken;
      }
    }
    return 0;
  }
}
